'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialNotificationsPaused = function SocialNotificationsPaused(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z' })
  );
};
SocialNotificationsPaused = (0, _pure2.default)(SocialNotificationsPaused);
SocialNotificationsPaused.displayName = 'SocialNotificationsPaused';
SocialNotificationsPaused.muiName = 'SvgIcon';

exports.default = SocialNotificationsPaused;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/social/notifications-paused.js
// module id = 3380
// module chunks = 0